import React, { useState, useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import styles from '../styles/Header.module.css';
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";

export default function Header({
  logo = null,
  logoText = 'Toby Transfers',
  actions = [],
  showSocial = false,
  socialLinks = [],
  className = '',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const { lang } = useParams();
  const { t } = useTranslation();

useEffect(() => {
  let timeout = null;

  const handleScroll = () => {
    const isScrolled = window.scrollY > 40;

    // If scrolling down → apply immediately
    if (isScrolled) {
      setScrolled(true);

      // clear any pending "reset"
      if (timeout) clearTimeout(timeout);
    } else {
      // If scrolling up → delay the reset
      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(() => {
        setScrolled(false);
      }, 1000); // ⏳ 1 second delay
    }
  };

  window.addEventListener("scroll", handleScroll, { passive: true });

  return () => {
    window.removeEventListener("scroll", handleScroll);
    if (timeout) clearTimeout(timeout);
  };
}, []);

  const closeMenu = () => setIsOpen(false);

  const buildPath = (path) => {
    if (!lang) return path;
    return path === "/" ? `/${lang}` : `/${lang}${path}`;
  };

  const mainLinks = [
    { label: t("navbar.home"), to: "/" },
    { label: t("navbar.contact"), to: "/contact" },
    { label: t("navbar.discover"), to: "/discover" },
    { label: t("navbar.book"), to: "/book" },
  ];

  return (
    <header className={`
      ${styles.header}
      ${scrolled ? styles.scrolled : ''}
      ${className}
    `}>

      <LanguageSwitcher />

      <div className={styles.inner}>

        {/* Logo */}
        <div className={styles.logoWrapper}>
          <NavLink
            to={buildPath("/")}
            onClick={closeMenu}
            className={styles.logoText}
          >
            {logo || logoText}
          </NavLink>
        </div>

        {/* Desktop Nav */}
        <nav className={styles.navDesktop}>

          <div className={styles.mainLinks}>
            {mainLinks.map((item) => (
              <NavLink
                key={item.to}
                to={buildPath(item.to)}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.active : ''}`
                }
                onClick={closeMenu}
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          <div className={styles.actions}>
            {actions.map((item) => (
              <NavLink
                key={item.to}
                to={buildPath(item.to)}
                className={({ isActive }) =>
                  `${styles.action} ${styles[item.variant || 'text']} ${
                    isActive ? styles.active : ''
                  }`
                }
                onClick={closeMenu}
              >
                {item.label}
              </NavLink>
            ))}
          </div>

        </nav>

        {/* Hamburger */}
        <button
          className={`
            ${styles.hamburger} 
            ${isOpen ? styles.open : ''}
            ${scrolled ? styles.hamburgerScrolled : ''}
            `}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={styles.bar} />
          <span className={styles.bar} />
          <span className={styles.bar} />
        </button>

      </div>

      {/* Mobile Menu */}
      <nav className={`${styles.mobileMenu} ${isOpen ? styles.open : ''}`}>
        <div className={styles.mobileInner}>

          {mainLinks.map((item) => (
            <NavLink
              key={item.to}
              to={buildPath(item.to)}
              end={item.to === "/"}
              className={({ isActive }) =>
                `${styles.mobileLink} ${isActive ? styles.active : ''}`
              }
              onClick={closeMenu}
            >
              {item.label}
            </NavLink>
          ))}

          {actions.map((item) => (
            <NavLink
              key={item.to}
              to={buildPath(item.to)}
              className={styles.mobileAction}
              onClick={closeMenu}
            >
              {item.label}
            </NavLink>
          ))}

        </div>
      </nav>

    </header>
  );
}